import { NgModule } from '@angular/core';
import { AmdSidenavService } from './sidenav.service';
import { AmdSidenavComponent } from './sidenav.component';
var AmdSidenavModule = /** @class */ (function () {
    function AmdSidenavModule() {
    }
    AmdSidenavModule.decorators = [
        { type: NgModule, args: [{
                    exports: [AmdSidenavComponent],
                    declarations: [AmdSidenavComponent],
                    providers: [AmdSidenavService]
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdSidenavModule.ctorParameters = function () { return []; };
    return AmdSidenavModule;
}());
export { AmdSidenavModule };
function AmdSidenavModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdSidenavModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdSidenavModule.ctorParameters;
}
//# sourceMappingURL=sidenav.module.js.map
//# sourceMappingURL=sidenav.module.js.map
